import {PropsWithChildren, ReactNode, SyntheticEvent} from 'react'
import {CardTitle} from '../../../genericComponents/typographie/CardTitle'
import {Description} from '../../../genericComponents/typographie/Description'
import styles from'./ItemTypeChoiceCard.module.scss'
import ItemTypeChip from '../../../item/ItemTypeChip'
import { ItemTypeEnum } from '../../../item/model/ItemType'
import { NavLink } from 'react-router-dom'
import { ROUTES } from '../../../constants/routing'
import { useDatxPathGenerator } from '../../../util/routing'

const NewItemServiceRequestChoiceCard = ({
                                                    icon,
                                                    title,
                                                    children,
                                                    id,
                                                    isDisabled = false,
                                                    to
                                                }: {
    icon?: ReactNode,
    title?: string,
    id: string,
    isDisabled?: boolean,
    to: string
} & PropsWithChildren) => {

    const onClick = (event: SyntheticEvent) => {
        if (isDisabled) event.preventDefault()
    }

    return (
        <NavLink
            replace
            to={to}
            onClick={onClick}
            className={({isActive}) => {
                return `${styles['service-request-choice-card']} ${isActive ? styles['card-active'] : ''} ${isDisabled ? styles['card-disabled'] : ''}  ${!children ? styles['small'] : ''}`
            }}
            data-testid={id}
            id={id}
        >
                <div className={styles['icon-container']}>
                    {icon && <div className={styles['card-icon']}>{icon}</div>}
                    {title && <CardTitle title={title}>{title}</CardTitle>}
                </div>
                {children && <Description className={styles['card-description']}>{children}</Description>}
        </NavLink>
                          
        
    )
}

export const ItemTypeChoice = () => {

    const generatePath = useDatxPathGenerator()

    return (
        <div className={styles['service-request-choice-cards']}>
            <NewItemServiceRequestChoiceCard 
                icon={<><ItemTypeChip itemTypeLabel={ItemTypeEnum.MANUFACTURER}/><span className="description">(Source Item)</span></>}
                id="manufacturer-type-choice-card"
                to={generatePath(ROUTES.newManufacturerItemsServiceForm.path)}
            >
                <span>Component identified by a unique vendor or <span className={styles['text-bold']}>manufacturer reference</span>.</span>
            </NewItemServiceRequestChoiceCard>
            <NewItemServiceRequestChoiceCard 
                icon={<ItemTypeChip itemTypeLabel={ItemTypeEnum.COMPANY}/>}
                id="company-type-choice-card"
                isDisabled={true}
                to=""
            >
                <span>Component identification in the <span className={styles['text-bold']}>organization codification system</span> like a BCN identification.</span>
            </NewItemServiceRequestChoiceCard>
            <NewItemServiceRequestChoiceCard
                icon={<ItemTypeChip itemTypeLabel={ItemTypeEnum.ABSTRACT}/>}
                id="abstract-type-choice-card"
                isDisabled={true}
                to=""
            >
                <span>Component defined by a <span className={styles['text-bold']}>technical standard</span> or functional specification.</span>
            </NewItemServiceRequestChoiceCard>
        </div>
    )
}

export const ItemCategoryChoice = () => {

    const generatePath = useDatxPathGenerator()

    return (
        <div className={styles['service-request-choice-cards']}>
            <NewItemServiceRequestChoiceCard 
                title="Hardware"   
                icon={<img src="/images/services/HardwareCategory.svg"/>}
                id="hardware-category-choice-card"
                to={generatePath(ROUTES.newManufacturerHardwareItemsServiceForm.path)}
            />
            <NewItemServiceRequestChoiceCard 
                title="Chemical"   
                icon={<img src="/images/services/ChemicalCategory.svg"/>}
                id="chemical-category-choice-card"
                isDisabled={true}
                to=""
            />
            <NewItemServiceRequestChoiceCard 
                title="Software"   
                icon={<img src="/images/services/SoftwareCategory.svg"/>}
                id="software-category-choice-card"
                isDisabled={true}
                to=""
            />
        </div>
    )
}